import { AppHelper } from "../appHelper.js";
import { AppBaseProps, CommonApp, Entity } from "../core/components/commonApp.js";
import { Grid } from "../core/components/grid.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { Config } from "../core/config/config.js";
import { TravelDayGrid } from "./travelDayGrid.js";
import ChangePeriodDialog from "./changePeriodDialog.js";
import { Helper } from "../core/util/helper.js";
import { TravelReportCashExpensesInGrid } from "./travelReportCashExpensesInGrid.js";
import { CashExpenseEntity, LbTravelDay, TravelData, TravelReportEntity, TravelReportFilter } from "./travelReportInterfaces.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export class EditTravelReportApp extends React.Component<EditTravelReportProps, EditTravelReportState>{
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;
    travelGridOptions: {};
    travelPlaceGridOptions: {};
    travelDayGridOptions: {};
    inGridCashExpenseOptions: {};
    inGridTravelDayGridOptions: {}
    expensesGridRef: TravelDayGrid;
    cashExpensesGridRef: TravelReportCashExpensesInGrid;
    changePeriodDialogRef: ChangePeriodDialog;
    lockId = null;

    constructor(props: EditTravelReportProps) {
        super(props);
        this.common.init(this);
        this.state = {
            NewStart: this.props.entity.TravelReport.Start,
            NewEnd: this.props.entity.TravelReport.End
        };
        let that = this;
        if (props.entity.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(function () {
                that.releaseLock();
            });
        }
        this.setLock();
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case "entity.TravelReport.IsReleased":
                if (!value) {
                    this.props.entity.TravelReport.IsReleasedCommercial = value;
                }
                break;
        }
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    componentDidMount() {
        this.getTravelReport();
        this.props.dataSources["currenciesDataSource"] = this.props.entity.TravelReport.ConvertToTargetCurrencies;
    }

    getTravelReport = async () => {
        const dataURL = `TravelReportEdit/GetTravelReportVm?isReadonly=${this.props.isReadonly ?? false}&belegnr=${this.props.entity.TravelReport.BelegNr}`;
        let result = await HTTPService.get<JsonResultClass<TravelReportEntity>>(dataURL);
        if (result.Code == 0) {
            let data = result.Data;
            this.props.entity.IsTemporaryEditing = false;
            Helper.updateEntity(this.props.entity.RecordRight, data.RecordRight);
            Helper.updateEntity(this.props.entity.TravelReport, data);
            this.setState({});
        }
        else
            NotificationHelper.showErrorMessage(result.Message)
    }

    deleteTravelReport = async () => {
        let isOk = await DialogHelper.confirm(Config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post<JsonResultClass>("TravelReport/DeleteTravelReport?belegNr=" + this.props.entity.TravelReport.BelegNr);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(this.translations["Ressource.LöschenErfolgreich"]);
                this.closeWindow();
            }
            else
                NotificationHelper.showErrorMessage(result.Message);
        };
    }

    refreshTravelData = async () => {
        let isOk = await DialogHelper.choose(this.translations["WebSMS.TravelReport.ChangePeriodMessage"],
            [{ label: this.translations["Server.No"], value: 1 }, { label: this.translations["Server.Yes"], value: 0 }], true);
        if (isOk != null && isOk >= 0) {
            this.refreshTravelDataInternal(isOk == 0);
        };
    }

    private async refreshTravelDataInternal(takeOverSettings: boolean) {
        let result = await HTTPService.post<JsonResultClass<TravelReportEntity>>("TravelReportEdit/RefreshTravelData?travelReportNr=" + this.props.entity.TravelReport.BelegNr
            + "&takeOverSettings=" + takeOverSettings
            + "&isTemporaryEditing=" + encodeURIComponent(this.props.entity.IsTemporaryEditing));
        if (result.Code == 0) {
            this.getTravelReport();
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }


    openChangePeriodDialog = () => {
        this.changePeriodDialogRef.openDialog();
    }

    changeTravelReportPeriod = async () => {
        let filter: TravelReportFilter = { RessNr: this.props.entity.TravelReport.RessNr, Start: this.state.NewStart, End: this.state.NewEnd };
        let result = await HTTPService.post<JsonResultClass<TravelData>>("TravelReportEdit/ChangeTravelReportPeriod?travelReportNr=" + this.props.entity.TravelReport.BelegNr
            + "&isTemporaryEditing=" + encodeURIComponent(this.props.entity.IsTemporaryEditing), filter);
        if (result.Code == 0) {
            this.getTravelReport();
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
            this.resetNewPeriod();
        }
    }

    resetNewPeriod = () => {
        this.setState({ NewStart: this.props.entity.TravelReport.Start, NewEnd: this.props.entity.TravelReport.End });
    }

    saveTravelReport = async (): Promise<boolean> => {
        let result = await this.saveTravelReportInternal();

        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(this.translations["Standard.Msg.SpeichernErfolgreich"]);
            this.getTravelReport();
            this.common.setEntityDirtyState(false);
            this.common.handlePostSave(result.Code === 0, false);
            return true;
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
            return false;
        }
    }

    closeWindow = () => {
        if (this.common.isWindow) {
            this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
            this.common.sheetWrapper.hide();
        } else {
            this.props.entity.RecordRight.CanWrite = false;
            this.setState({});
            setTimeout(() => {
                if(Config.settings.isMobileApp)
                    window.location.href = Config.baseUrl + "TravelReport";
                else
                    window.location.href = Config.baseUrl + "DynamicSearch/travelReport";
            }, 1000);
        }
    }

    saveBeforeIfEntityChanged = async (action: () => void) => {
        if (this.common.entityChanged)
            this.saveTravelReport().then((successful) => {
                if (successful)
                    action();
            })
        else
            action();
    }

    setTechnicalRelease = async () => {
        this.saveBeforeIfEntityChanged(() => {
            HTTPService.post<JsonResultClass<TravelReportEntity>>("TravelReportEdit/SetTechnicalRelease?travelReportNr=" + this.props.entity.TravelReport.BelegNr).then(result => {
                if (result.Code == 0) {
                    this.setReleases();
                }
                else
                    NotificationHelper.showErrorMessage(result.Message)
            })
        });
    }

    setCommercialRelease = async () => {
        this.saveBeforeIfEntityChanged(() => {
            HTTPService.post<JsonResultClass<TravelReportEntity>>("TravelReportEdit/SetCommercialRelease?travelReportNr=" + this.props.entity.TravelReport.BelegNr).then(result => {
                if (result.Code == 0) {
                    this.setReleases();
                }
                else
                    NotificationHelper.showErrorMessage(result.Message)
            })
        });
    }

    removeTechnicalRelease = async () => {
        this.saveBeforeIfEntityChanged(() => {
            HTTPService.post<JsonResultClass<TravelReportEntity>>("TravelReportEdit/RemoveTechnicalRelease?travelReportNr=" + this.props.entity.TravelReport.BelegNr).then(result => {
                if (result.Code == 0) {
                    this.setReleases();
                }
                else
                    NotificationHelper.showErrorMessage(result.Message)
            })
        });
    }

    removeCommercialRelease = async () => {
        this.saveBeforeIfEntityChanged(() => {
            HTTPService.post<JsonResultClass<TravelReportEntity>>("TravelReportEdit/RemoveCommercialRelease?travelReportNr=" + this.props.entity.TravelReport.BelegNr).then(result => {
                if (result.Code == 0) {
                    this.setReleases();
                }
                else
                    NotificationHelper.showErrorMessage(result.Message)
            })
        });
    }

    complete = async () => {
        let msg = Config.settings.isMobileApp ? Helper.getTranslation("WebSMS.TravelReport.MsgComplete") : Helper.getTranslation("WebSMS.TravelReport.MsgTakeOver");
        if (!await DialogHelper.confirm(msg))
            return;

        this.saveBeforeIfEntityChanged(() => {
            HTTPService.post<JsonResultClass>("TravelReportEdit/SetReportedBack?travelReportNr=" + this.props.entity.TravelReport.BelegNr).then(result => {
                if (result.Code == 0) {
                    this.getTravelReport();
                    NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
                }
                else
                    NotificationHelper.showErrorMessage(result.Message)
            })
        });
    }

    handoverToMobileApp = async () => {
        this.saveBeforeIfEntityChanged(() => {
            HTTPService.post<JsonResultClass>("TravelReportEdit/HandoverToMobileApp?travelReportNr=" + this.props.entity.TravelReport.BelegNr).then(result => {
                if (result.Code == 0) {
                    this.getTravelReport();
                    NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
                }
                else
                    NotificationHelper.showErrorMessage(result.Message)
            })
        });
    }

    enable = () => {
        this.props.entity.RecordRight.CanWrite = true;
        this.props.entity.TravelReport.RecordRight.CanWrite = true;
        this.props.entity.IsTemporaryEditing = true;
        NotificationHelper.showSuccessMessage(Helper.getTranslation("WebSMS.ServiceReport.CanBeEdit"));
        this.setState({});
    }

    private async saveTravelReportInternal() {
        let changedExpenses: any[] = null;
        if (this.expensesGridRef) {
            const dataSource = this.expensesGridRef.editableGridRef.getDataSource();
            changedExpenses = dataSource["updated"]();
        }

        let changedCashExpenses: any[] = null;
        let newCashExpenses: any[] = null;
        let deletedCashExpenses: any[];
        if (this.cashExpensesGridRef != null) {
            const dataSourceCashExpenses = this.cashExpensesGridRef.editableGridRef.getDataSource();
            changedCashExpenses = dataSourceCashExpenses["updated"]();
            newCashExpenses = dataSourceCashExpenses["created"]();
            deletedCashExpenses = dataSourceCashExpenses["destroyed"]();
        }
        const saveEntity: UpdateTravelReportEntity = {
            HeadData: this.props.entity.TravelReport,
            ChangedTravelDays: changedExpenses,
            ChangedCashExpenses: changedCashExpenses,
            NewCashExpenses: newCashExpenses,
            DeletedCashExpenses: deletedCashExpenses,
            IsTemporaryEditing: this.props.entity.IsTemporaryEditing
        };

        let result = await HTTPService.post<JsonResultClass<void>>("TravelReportEdit/UpdateTravelReport", saveEntity);
        return result;
    }

    setReleases() {
        this.getTravelReport();
        $(window).trigger("toggleDocumentUpload", { allow: this.props.entity.RecordRight.CanWrite });
        this.setState({});
    }

    onChange = () => {
        this.common.setEntityDirtyState(true);
    }

    renderTravelGrid = () => {
        let content = <Grid data={this.props.entity.TravelReport.TravelData.Travels} options={this.travelGridOptions} id="editTravelGrid" />
        return content;
    }

    renderPlaceGrid = () => {
        let content = <Grid data={this.props.entity.TravelReport.TravelData.TravelPlaces} options={this.travelPlaceGridOptions} id="travelPlaceGrid" />
        return content;
    }

    renderTravelDayGrid = (defaultFieldProps: any) => {
        return <TravelDayGrid entity={this.props.entity.TravelReport}
            data={this.props.entity.TravelReport.TravelData.TravelDays}
            gridOptions={this.inGridTravelDayGridOptions} ref={(ref) => this.expensesGridRef = ref}
            translations={this.translations}
            onChange={this.onChange} helpEditUrl={defaultFieldProps.helpUrl} id={""} />
    }

    renderCashExpensesGrid = (defaultFieldProps: any) => {
        return <TravelReportCashExpensesInGrid entity={this.props.entity.TravelReport}
            data={this.props.entity.TravelReport.CashExpenses}
            gridOptions={this.inGridCashExpenseOptions}
            ref={(ref) => this.cashExpensesGridRef = ref}
            translations={this.translations}
            onChange={this.onChange} dataSources={this.props.dataSources}
            helpEditUrl={defaultFieldProps.helpUrl} id={""} />
    }

    getChangePeriodDialog = () => {
        return <ChangePeriodDialog
            title={this.translations["WebSMS.TravelReport.ChangePeriod"]}
            currentStart={this.props.entity.TravelReport.Start}
            currentEnd={this.props.entity.TravelReport.End}
            newStart={JSON.parse(JSON.stringify(this.state.NewStart))}
            newEnd={JSON.parse(JSON.stringify(this.state.NewEnd))}
            onStartChange={(value: Date) => this.setState({ NewStart: value })}
            onEndChange={(value: Date) => this.setState({ NewEnd: value })}
            ref={(ref) => this.changePeriodDialogRef = ref}
            translations={this.translations}
            onDialogOk={this.changeTravelReportPeriod}
            onDialogCancle={this.resetNewPeriod}
        />
    }

    getIsCommercialReleasedLabel = () => {
        if (this.props.entity.TravelReport.IsInvoiced || !this.props.entity.TravelReport.IsReleasedCommercial)
            return null;
        const labelStyle: React.CSSProperties = {
            color: "#ff0000"
        }
        var text = Helper.getTranslation("WebSMS.TravelReport.ReleasedForInvoicing");
        return <label style={labelStyle}>{text}</label>
    }

    getIsInvoicedLabel = () => {
        if (!this.props.entity.TravelReport.IsInvoiced)
            return null;
        const labelStyle: React.CSSProperties = {
            color: "#ff0000"
        }
        var text = Helper.getTranslation("WebSMS.TravelReport.ServiceReportInvoiced");
        return <label style={labelStyle}>{text}</label>
    }

    renderChangePeriod = () => {
        return <div className="field-action" onClick={this.openChangePeriodDialog}>
            <i className="fal fa-clock" style={{ marginInline: "0.3em" }}></i>
            {Helper.getTranslation("WebSMS.TravelReport.ChangePeriod")}
        </div>
    }

    setLock = () => {
        if (this.lockId === null && this.props.entity.RecordRight.CanWrite && !this.props.entity.IsNew) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.TravelReport.BelegNr, "LBKOPF", 10000);
        }
    }

    releaseLock = () => {
        if (this.lockId !== null) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.TravelReport.BelegNr, "LBKOPF");
            this.lockId = null;
        }
    }

    render() {
        const props = {
            ...this.props,
            ...this.common.getHandlersForProps(),
            handleFieldChange: this.handleFieldChange,
            //context: { ...this.props.context, Countries: this.state.Countries}  
        };
        const changePeriodDialog = this.getChangePeriodDialog();

        return (<>
            {changePeriodDialog}
            <CommonApp {...props} />
        </>);
    }
}

export interface EditTravelReportProps extends AppBaseProps {
    entity: EditTravelReportEntity;
    isReadonly: boolean;
}

export interface EditTravelReportEntity extends Entity {
    TravelReport: TravelReportEntity;
    IsTemporaryEditing: boolean;
}

export interface EditTravelReportState {
    NewStart: Date;
    NewEnd: Date;
}

export interface UpdateTravelReportEntity {
    HeadData: TravelReportEntity;
    ChangedTravelDays: LbTravelDay[];
    ChangedCashExpenses: CashExpenseEntity[];
    NewCashExpenses: CashExpenseEntity[];
    DeletedCashExpenses: CashExpenseEntity[];
    IsTemporaryEditing: boolean;
}



